import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_user = (userName, passWord, NickName) => {
  return api.post(`${ApiEndpointConstants.ADDUSER}`, {
    userName,
    passWord,
    NickName,
  });
};
